import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';

import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import AppContainer from './Dashboard.vue';
import Captain from './Captain.vue';
import Suspended from './suspended/Index.vue';
import StartChat from '../custom/StartChat.vue';
import store from 'dashboard/store';
const Kanban = () => import('./kanban/Index.vue');

export default {
  routes: [
    {
      path: '/app/start',
      name: 'start-short',
      beforeEnter: async (to, from, next) => {
        await store.dispatch('setUser');
        const { isLoggedIn, getCurrentUser } = store.getters;
        if (!isLoggedIn) {
          return next('/app/login');
        }
        const accountId = getCurrentUser.account_id;
        return next({
          name: 'start-chat', // rota interna correta
          params: { accountId }, // insere o accountId na URL final
          query: to.query, // <-- preserva todos os query params
        });
      },
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
    },
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        {
          path: frontendURL('accounts/:accountId/captain/:page'),
          name: 'captain',
          component: Captain,
          meta: {
            permissions: ['administrator', 'agent'],
            featureFlag: FEATURE_FLAGS.CAPTAIN,
          },
          props: true,
        },
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        {
          path: frontendURL('accounts/:accountId/kanban'),
          name: 'kanban',
          component: Kanban,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
        {
          path: frontendURL('accounts/:accountId/start'),
          name: 'start-chat',
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
          component: StartChat,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
  ],
};
